import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles, platform }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-slate-500" data-testid="auth-loading">
        Loading Support By ERP4U…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (platform && !user.is_platform) return <Navigate to="/dashboard" replace />;
  if (!platform && user.is_platform) return <Navigate to="/admin" replace />;
  if (roles && roles.length && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
